import * as React from "react";
import Ajax from "../../Ajax";
import swal from 'sweetalert';
import TypesList from "./TypesList";
import CheckoutList from "./CheckoutList";
import PlacesList from "./PlacesList";

interface IFormProps {
  id: number,
  setForEdit: any,
  dontAddNew: any
}
interface MyStates {
  ajaxLoaded: boolean,
  session_id: any,
  spinner: string,
  types: object,
  order: object,
  depedencies: any,
  group: boolean,
  booking: boolean,
  meal: boolean,
  services: object,
  cart: object,
  cartItems: number,
  places: object,
  placesItems: number,
  typesItems: number,
  places_from_date: string,
  places_to_date: string,
  group_size: number,
  selected_places: object,
  city: string,
  peopleCount: number,
  iscompany: boolean,
  isDisabled: boolean,
  churchperson: boolean,
  underage_people_count: number,
  churchpersonnumber: number,
  approval_select_value: string,
  request_for_bed_linen: boolean,
  current_step: string,
  noServicesChecked: Array<boolean>,
}
export default class EditOrder extends React.Component<IFormProps, MyStates>{

  constructor(props:IFormProps) {
    super(props);

    this.state = {
      ajaxLoaded: false,
      session_id: this.props.id,
      spinner: 'none',
      types: {},
      order: {},
      depedencies: [],
      group: true,
      booking: false,
      meal: false,
      services: {},
      cart: {},
      cartItems: 0,
      places: {},
      placesItems: 0,
      typesItems: 0,
      places_from_date: '',
      places_to_date: '',
      group_size: 0,
      selected_places: {},
      city: '',
      peopleCount: 0,
      iscompany: false,
      isDisabled: false,
      churchperson: false,
      underage_people_count: 0,
      churchpersonnumber: 0,
      approval_select_value: '',
      request_for_bed_linen: true,
      current_step: 'orderData',
      noServicesChecked: [],

    }
    this.getData()
  }

  private getData() {
    var ajax = new Ajax(window.location.origin+ '/reservatio/foglalasok/loadOrder');
    ajax.doPost({id: this.props.id, company: true}).then((response) => {
      this.setState({
        ajaxLoaded: true, 
        types: response.types,
        order: response.order,
        city: response.order['billing_city'],
        places_from_date: response.order?.arrival_date,
        places_to_date: response.order?.departure_date,
        booking: response.order?.need_booking == 'on' ? true : false,
        meal: response.order?.need_meal != 'no' ? true : false,
        group_size:  response.order?.group_size,
        group: response.order?.mode == 'group'? true : false, 
        iscompany: response.order?.is_company != 'no' ? true : false,
        isDisabled: response.order?.disabled_people_count > 0 ? true : false,
        churchperson: response.order?.church_person != 'no' ? true : false,
        underage_people_count: response.order?.underage_people_count ?? 0,
        churchpersonnumber: response.order?.churchpersonnumber ?? 0,
        approval_select_value: response.order?.['approval'],
        spinner: 'none',
        request_for_bed_linen: response.order?.request_for_bed_linen != 'no' ? true : false
          },
        () => this.loadPlaces())
    })
  }

  private loadCart() {
    var ajax = new Ajax(window.location.origin+ '/api/ordering/loadCart');
    ajax.doPost({
      session_id: this.state.session_id, 
      group_size: this.state.group_size, 
      from: this.state.places_from_date, 
      to: this.state.places_to_date,
      underage_people_count: this.state.underage_people_count,
      churchpersonnumber: this.state.churchpersonnumber,
      available_places: this.state.places,
      request_for_bed_linen: this.state.request_for_bed_linen
    }).then((response) => {
      console.log(response);
      this.setState({
        ajaxLoaded: true, 
        cart: response.services,
        selected_places: response.places,
        cartItems: Object.keys(response.services).length > 0 ? Math.random() : 0,
        placesItems: Math.random(),
        spinner: 'none'}, () => {
          if( response?.places_removed == 'yes' ){
            swal({
              title: "Figyelem!",
              text: "Egy, vagy több tétel kikerült a foglalásból, mivel az adott időpontban nem elérhetőek!",
              icon: "info",
            });
          }
        })
    })
  }

  private loadPlaces() {
    
    if( this.state.places_from_date != null && this.state.places_to_date != null ){
      var ajax = new Ajax(window.location.origin+ '/api/ordering/loadPlaces');
      ajax.doPost({session_id: this.state.session_id, from: this.state.places_from_date, to: this.state.places_to_date, isdisabled: this.state.isDisabled}).then((response) => {
        if( response.status == 'success' ){
          this.setState({
            ajaxLoaded: true, 
            places: response.places,
            cartItems: Math.random(),
            placesItems: Math.random(),
          }, () => this.loadCart())
        } else {
          swal({
            title: "Hiba történt!",
            text: response.message,
            icon: "error",
          });
        }
      })
    }else{
      this.loadCart()
    }
  }
  private updateDates(e, type){
    if( type == 'from'){
      this.setState({places_from_date: e.target.value}, () => this.loadPlaces())
    }
    if( type == 'to'){
      this.setState({places_to_date: e.target.value}, () => this.loadPlaces())
    }
  }

  private handleSubmit(e){
    e.preventDefault();

    this.setState({
      spinner: 'flex',
    }, () => {
      var ajax = new Ajax(window.location.origin+ '/reservatio/foglalasok/create');
      ajax.doPost('new_order', true).then((response) => {
        if( response.status !== undefined && response.status === 'success' ){
          swal({
            title: "Siker!",
            text: "A foglalás módosult!",
            icon: "success",
          });
          this.props.dontAddNew()
        } else {
          swal({
            title: "Hiba történt!",
            text: "Nem sikerült a foglalást leadni!",
            icon: "error",
          });
        }
      })
    })
  }

  private setOrderMode(e){
    this.setState({group: e.target.value == 'group' ? true : false})
  }
  private setBooking(e){
    this.setState({booking: !this.state.booking}, () => this.loadCart())
  }
  private setMeal(e){
    this.setState({meal: e.target.checked})
  }

  private setGroupSize(e){
    if(e.target.value > 60 && this.state.booking ){
      swal({
        title: "Figyelem!",
        text: "60 fő felett csak sátor hely foglalható, azonban a sátrat minden vendégnek magának kell biztosítania.",
        icon: "warning",
      });
    }
    this.setState({group_size: e.target.value},
        () => this.loadCart())
  }
  
  private setServices(s){
    this.setState({services: {...this.state.services, s}})
  }
  private removeService(key){
    let services = this.state.services
    delete services[key]
    this.setState({services: services})
  }

  private setZip(e){
    var ajax = new Ajax(window.location.origin+ '/api/ordering/getcity');
    ajax.doPost({zip: e.target.value}).then((response) => {
      this.setState({
        city: response.city,
      }) 
    })
  }

  private setCity(e){
    this.setState({city: e.target.value}); 
  }
  
  private checkPeopleCount(e){
    if(e.target.value > 2){
      swal({
        title: "Hiba történt!",
        text: "Mozgássérült személyből max. 2 fő szállhat meg",
        icon: "error",
      });      
    }

    if(e.target.value > 0 && e.target.value <= 2){
      this.setState({isDisabled: true},
        () => this.loadPlaces())
    }

    if(e.target.value == 0 || e.target.value == ''){
      this.setState({isDisabled: false},
        () => this.loadPlaces())
    }
  }

  private isCompany(e){
    this.setState({iscompany: e.target.checked});
  }

  private setChurchPerson(e){
    if(!e.target.checked){
      this.setState({churchpersonnumber: 0});
    }
    this.setState({churchperson: e.target.checked}, () => this.loadCart());
  }

  private setUnderRageCount(e){
    this.setState({underage_people_count: e.target.value}, () => this.loadCart())
  }

  private setChurchPersonCount(e){
    this.setState({churchpersonnumber: e.target.value}, () => this.loadCart())
  }

  private setRequestForBedLinen(e){
    this.setState({request_for_bed_linen: e.target.checked}, () => this.loadCart())
  }

  private setCurrentStep(step){
    this.setState({current_step: step});
  }

  private handleNoServicesChecked(serviceSerial: number, checked: boolean) {

    this.setState((prevState) => {
      let noServicesChecked = prevState.noServicesChecked;
      noServicesChecked[serviceSerial] = checked;
      return { noServicesChecked: noServicesChecked };
    });
  }

  private OrderData() {
    return (
        <>
          <div className="row">
            <div className="col-md-6 form-group">
              <div className="input-group">
                      <span className="input-group-addon width-130px">
                        Kapcsolattartó:
                      </span>
                <input type="text" name="contact_name" defaultValue={this.state.order?.['contact_name']} className="form-control" placeholder="Kapcsolattartó neve" required />
              </div>
            </div>
            <div className="col-md-6 form-group">
              <div className="input-group">
                      <span className="input-group-addon width-130px">
                        Foglalás módja:
                      </span>
                <select name="mode" defaultValue={this.state.order?.['mode']} className="form-control" onChange={(e) => this.setOrderMode(e)} required>
                  <option value="group">Csoportos</option>
                  <option value="individual">Egyéni</option>
                </select>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 form-group">
              <div className="input-group">
                      <span className="input-group-addon width-130px">
                        Telefonszám:
                      </span>
                <input type="text" name="phone" defaultValue={this.state.order?.['phone']} className="form-control" placeholder="Telefonszám" required />
              </div>
            </div>
            <div className="col-md-6 form-group">
              <div className="input-group">
                      <span className="input-group-addon width-130px">
                        E-mail cím:
                      </span>
                <input type="email" name="email" defaultValue={this.state.order?.['email']} className="form-control" placeholder="E-mail cím" required />
              </div>
            </div>
          </div>
          <div className="row">
            {
              this.state.group ?
                  <div className="col-md-6 form-group">
                    <div className="input-group">
                          <span className="input-group-addon width-130px">
                            Csoport neve:
                          </span>
                      <input type="text" name="group_name" defaultValue={this.state.order?.['group_name']} className="form-control" placeholder="Csoport neve" required />
                    </div>
                  </div>
                  :<></>
            }
            <div className="col-md-6 form-group">
              <div className="input-group">
                        <span className="input-group-addon width-130px">
                          Létszám:
                        </span>
                <input type="number" name="group_size" defaultValue={this.state.order?.['group_size']} className="form-control" onBlur={(e) => this.setGroupSize(e)} placeholder="" max={!this.state.booking ? '1000' :'100'} required />
                <span className="input-group-addon">
                          Fő
                        </span>
              </div>
            </div>
          </div>

          <hr />
          <div className="row">
            <div className="col-md-6 form-group">
              <div className="input-group">
                      <span className="input-group-addon width-130px">
                        Érkezés célja:
                      </span>
                <input type = "text" name="purpose_of_arrival" defaultValue={this.state.order?.['purpose_of_arrival']} className="form-control"  required />

              </div>
            </div>
            <div className="col-md-6 form-group">
              <div className="input-group">
                <span className="input-group-addon height-34px">
                  Szeretnék szállást foglalni
                </span>
                <span className="input-group-addon">
                  <input type="checkbox" name="need_booking" defaultChecked={this.state.booking} onChange={(e) => this.setBooking(e)}/>
                </span>
              </div>
            </div>
          </div>
          {
            this.state.booking ?
                <>
                  <div className="row">
                    <div className="col-md-6 form-group">
                      <div className="input-group">
                          <span className="input-group-addon width-130px">
                            Érkezés:
                          </span>
                        <input type="date" name="arrival_date" defaultValue={this.state.order?.['arrival_date']} className="form-control" onChange={(e) => this.updateDates(e, 'from')} required />
                      </div>
                    </div>
                    <div className="col-md-6 form-group">
                      <div className="input-group">
                          <span className="input-group-addon width-130px">
                            Távozás:
                          </span>
                        <input type="date" name="departure_date" defaultValue={this.state.order?.['departure_date']} className="form-control" onChange={(e) => this.updateDates(e, 'to')} required />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 form-group">
                      <div className="input-group">
                          <span className="input-group-addon width-130px">
                            Mozgássérült:
                          </span>
                        <input type="number" name="disabled_people_count" defaultValue={this.state.order?.['disabled_people_count']} max='2' className="form-control" onBlur={(e) => this.checkPeopleCount(e)}/>
                        <span className="input-group-addon">
                            fő
                          </span>
                      </div>
                    </div>
                    <div className="col-md-6 form-group">
                      <div className="input-group">
                          <span className="input-group-addon width-130px">
                            18 év alatti:
                          </span>
                        <input type="number" name="underage_people_count" defaultValue={this.state.order?.['underage_people_count']} className="form-control" onChange={(e) => this.setUnderRageCount(e)}/>
                        <span className="input-group-addon">
                            fő
                          </span>
                      </div>
                    </div>
                    <div className="col-md-6 form-group">
                      <div className="input-group">
                      <span className="input-group-addon height-34px">
                        Ágynemű igénylés:
                      </span>
                        <span className="input-group-addon">
                        <input type="checkbox" name="request_for_bed_linen" defaultChecked={this.state.request_for_bed_linen} onChange={(e) => this.setRequestForBedLinen(e)}/>
                      </span>
                      </div>
                    </div>

                  </div>
                </>
                :<></>
          }
          <hr />
          <div className="row">
            <div className="col-md-6 form-group">
              <div className="input-group">
                      <span className="input-group-addon height-34px">
                        Jogi személy vagyok:
                      </span>
                <span className="input-group-addon">
                        <input type="checkbox" name="is_company" defaultChecked={this.state.iscompany} onChange={(e) => this.isCompany(e)} />
                      </span>
              </div>
            </div>
            <div className="col-md-6 form-group">
              <div className="input-group">
                      <span className="input-group-addon height-34px">
                        Szeretnék étkezést is igénybe venni:
                      </span>
                <span className="input-group-addon">
                        <input type="checkbox" name="need_meal" defaultChecked={this.state.meal} onChange={(e) => this.setMeal(e)} />
                      </span>
              </div>
            </div>

          </div>

          <hr />
          <div className="row">
            <div className="col-md-12 form-group">
              <div className="input-group">
                <label>Liturgikus esemény esetén:</label>
                <textarea className="form-control" defaultValue={this.state.order?.['liturgical_event_comment']} name="liturgical_event_comment" placeholder="Érkezik-e a csoporttal klerikus személy aki végzi szertartást, illetve énekes liturgikus esemény esetén érkezik-e kántor a csoporttal? A mező üresen hagyásával automatikusan kérik a helyi klerikus, illetve kántori szolgálatot."></textarea>
              </div>
            </div>
          </div>

          {
            this.state.booking ?
                <>
                  <h4>Elérhető szállások

                  </h4>
                  <div key={'places_' + this.state.placesItems}>
                    <PlacesList
                        session_id={this.state.session_id}
                        places={this.state.places}
                        selected_places={this.state.selected_places}
                        loadCart={() => this.loadCart()}
                        from={this.state.places_from_date}
                        to={this.state.places_to_date}
                        group_size={this.state.group_size}
                        underage_people_count={this.state.underage_people_count}
                        churchpersonnumber={this.state.churchpersonnumber}
                    />
                  </div>
                </>
                :<></>
          }

        </>
    );

  }

  public ServicesData(){
    return (
        <TypesList session_id={this.state.session_id} types={this.state.types} loadCart={() => this.loadCart()} onNoServicesChecked={this.handleNoServicesChecked.bind(this)} cartItems = {this.state.cart}/>
    );
  }

  public Checkout(){
    return (
        <div className="box">
          <div className="box-header">
            <h3 className="box-title">Megrendelés</h3>
          </div>
          <div className="box-body" style={{position: 'relative'}} key={"cart_" + this.state.cartItems}>
            <CheckoutList session_id={this.state.session_id} cart={this.state.cart} removeService={(e) => this.removeService(e)} loadCart={() => this.loadCart()} />
          </div>
        </div>
    )
  }

  public CheckoutData(){
    return (
        <>
          {
              this.state.cartItems > 0 &&
              <>
                {this.Checkout()}
                {this.BillingData()}
              </>
          }
        </>
    );
  }

  public BillingData(){
      return (
          <div className="box">
            <div className="box-body" style={{position: 'relative'}}>
              <div className="row">
                <div className="col-md-7 form-group">
                  <div className="input-group">
                      <span className="input-group-addon width-130px">
                        Számlázási név:
                      </span>
                    <input type="text" name="billing_name" defaultValue={this.state.order?.['billing_name']} className="form-control" placeholder="Számlázási név" required />
                  </div>
                </div>
                {this.state.iscompany &&
                    <div className="col-md-5 form-group">
                      <div className="input-group">
                      <span className="input-group-addon width-100px">
                      Adószám:
                      </span>
                        <input type="text" name="billing_tax_number" defaultValue={this.state.order?.['billing_tax_number']} className="form-control" placeholder="Adószám" required />
                      </div>
                    </div>
                }
              </div>
              <div className="row">
                <div className="col-md-5 form-group">
                  <div className="input-group">
                      <span className="input-group-addon width-130px">
                        Irányítószám:
                      </span>
                    <input type="number" name="billing_zip" defaultValue={this.state.order?.['billing_zip']} className="form-control" placeholder="Irányítószám" onBlur={(e) => this.setZip(e)} required />
                  </div>
                </div>
                <div className="col-md-7 form-group">
                  <div className="input-group">
                      <span className="input-group-addon width-100px">
                      Város:
                      </span>
                    <input type="text" name="billing_city" value={this.state.city} className="form-control" placeholder="Város" onChange={(e) => this.setCity(e)} required />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 form-group">
                  <div className="input-group">
                      <span className="input-group-addon width-130px">
                        Közterület:
                      </span>
                    <input type="text" name="billing_address" defaultValue={this.state.order?.['billing_address']} className="form-control" placeholder="Közterület" required />
                  </div>
                </div>
                <div className="col-md-2 form-group p-0">
                  <div className="input-group">
                    <select name="billing_address_type" defaultValue={this.state.order?.['billing_address_type']} className="form-control" required>
                      <option value="utca">utca</option>
                      <option value="út">út</option>
                      <option value="tér">tér</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-4 form-group">
                  <div className="input-group">
                      <span className="input-group-addon">
                      Házszám:
                      </span>
                    <input type="text" name="billing_address_number" defaultValue={this.state.order?.['billing_address_number']} className="form-control" placeholder="Házszám" required />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 form-group">
                  <div className="input-group">
                      <span className="input-group-addon width-130px">
                        Ország:
                      </span>
                    <select name="billing_country" defaultValue={this.state.order?.['billing_country']} className="form-control" required>
                      <option value="Magyarország">Magyarország</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-6 form-group">
                  <div className="input-group">
                      <span className="input-group-addon height-34px">
                        Egyházi személy vagyok:
                      </span>
                    <span className="input-group-addon">
                        <input type="checkbox" name="church_person" defaultChecked={this.state.churchperson} onChange={(e) => this.setChurchPerson(e)}/>
                      </span>
                  </div>
                </div>
              </div>
              {
                  this.state.churchperson &&
                  <>
                    <div className="row">
                      <div className="col-md-12 form-group">
                        <div className="input-group">
                        <span className="input-group-addon">
                        Érkező egyházi személyek száma:
                        </span>
                          <input type="number" name="churchpersonnumber" className="form-control" defaultValue={this.state.order?.['churchpersonnumber']}  onChange={(e) => this.setChurchPersonCount(e)} required/>
                        </div>
                      </div>
                    </div>
                  </>
              }
              <div className="row">
                <div className="col-md-3 form-group height-34px" style={{textAlign: 'right', width: '130px'}}>
                  Fizetés mód:
                </div>
                <div className="col-md-8 form-group">
                  <div className="input-group form-group">
                      <span className="input-group-addon height-34px">
                        Helyszínen készpénzzel vagy bankkártyával 
                      </span>
                    <span className="input-group-addon">
                        <input type="radio" name="payment_method" defaultChecked={this.state.order?.['payment_method'] == 'cash' ? true : false} value="cash" required />
                      </span>
                  </div>
                  <div className="input-group form-group">
                      <span className="input-group-addon height-34px">
                        Átutalásos fizetés
                      </span>
                    <span className="input-group-addon">
                        <input type="radio" name="payment_method" defaultChecked={this.state.order?.['payment_method'] == 'transfer' ? true : false} value="transfer" required />
                      </span>
                  </div>
                  <div className="input-group form-group">
                      <span className="input-group-addon height-34px">
                        Bankkártyás fizetés
                      </span>
                    <span className="input-group-addon">
                        <input type="radio" name="payment_method" defaultChecked={this.state.order?.['payment_method'] == 'simplepay' ? true : false} value="simplepay" required />
                      </span>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 form-group">
                  <textarea className="form-control" name="comment" defaultValue={this.state.order?.['comment']} placeholder="Megjegyzés"></textarea>
                </div>
              </div>
              {this.state.approval_select_value == 'received'?
                  <div className="row">
                    <div className="col-md-6 form-group">
                      <div className="input-group">
                            <span className="input-group-addon height-34px">
                              E-mail küldése a módosításról
                            </span>
                        <span className="input-group-addon">
                              <input type="checkbox" name="with_email" />
                            </span>
                      </div>
                    </div>
                    <div className="col-md-6 form-group">
                      <input type="hidden" name="session_id" defaultValue={this.state.session_id} />
                    </div>
                  </div>
                  :<></>
              }
              {this.state.approval_select_value == 'accepted'?
                  <>
                    <div className="row">
                      <div className="col-md-12 form-group">
                        <div className="input-group">
                              <span className="input-group-addon height-34px">
                                E-mail küldése az elfogadásról és simplepay vagy proforma generálása
                              </span>
                          <span className="input-group-addon">
                                <input type="checkbox" name="with_email" />
                              </span>
                        </div>

                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 form-group">
                      </div>
                      <div className="col-md-6 form-group">
                        <input type="hidden" name="session_id" defaultValue={this.state.session_id} />

                      </div>
                    </div>
                  </>
                  :<></>
              }
              {this.state.approval_select_value != 'accepted' && this.state.approval_select_value != 'received'?
                  <>
                    <div className="row">
                      <div className="col-md-6 form-group">
                      </div>
                      <div className="col-md-6 form-group">
                        <input type="hidden" name="session_id" defaultValue={this.state.session_id} />
                      </div>
                    </div>
                  </>
                  :<></>
              }
            </div>
          </div>
      );
  }


  public Buttons(){
    let buttons = [];
    buttons.push('orderData');
    Object.keys(this.state.types).map((i) => {
      if(this.state.types[i].services && this.state.types[i].services.length > 0) {
        buttons.push('servicesData'+i);
      }
    })
    buttons.push('checkoutList');

    return (
        <div className="btns" style = {{float: 'right'}}>
          <a onClick={() => this.setCurrentStep(buttons[buttons.indexOf(this.state.current_step)-1])} href = {'#'+buttons[buttons.indexOf(this.state.current_step)-1]} data-toggle="tab" style = {{marginRight: '10px'}} className={'btn btn-primary btn-lg'}>Vissza</a>
          {
            this.state.current_step == 'checkoutList' ?
                <button type="submit" className="btn btn-success btn-lg">Megrendelés módosítása</button> :
                <a onClick={() => this.setCurrentStep(buttons[buttons.indexOf(this.state.current_step)+1])} href = {'#'+buttons[buttons.indexOf(this.state.current_step)+1]} data-toggle="tab" className="btn btn-success btn-lg">Tovább</a>
          }
        </div>
    );
  }

  public render() {
    if( this.state.ajaxLoaded ){
      return (
      <>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <button className="btn btn-success btn-sm" onClick={() => this.props.dontAddNew()}><i className="fa fa-plus"></i> Vissza</button>
          </div>
        </div>
        
      </div>
    
      <form id="new_order" onSubmit={(e) => this.handleSubmit(e)}>
        <div className = "row">
        <div className="col-md-3 pull-right">
          <div className="form-group">
            <div className="input-group">
              <span className="input-group-addon">
                Foglálás státusza:
              </span>	
              <select name = "approval" className = "form-control" defaultValue={this.state.approval_select_value} onChange={(e) => this.setState({approval_select_value:e.target.value})} >
                <option value="received">Beérkezett</option>
                <option value="accepted">Elfogadva</option>
                <option value="payed">Fizetve</option>
                <option value="free">Grátis</option>
                <option value="denied">Lemondva</option>
              </select>
            </div>
          </div>
        </div>
        </div>
        <div className="row" style = {{display: 'flex', justifyContent:'center'}}>
        <div className="col-md-7">
          <div className="panel with-nav-tabs panel-default panel-custom">
            <div className="panel-heading">
              <ul className="nav nav-tabs" id = "order-tab">
                <li className = {this.state.current_step == 'orderData' ? "active" : ""}><a onClick={() => this.setCurrentStep('orderData')} href="#orderData" data-toggle="tab">Foglalási adatok</a></li>
                {
                  Object.keys(this.state.types).map((i) => (
                      this.state.types[i].services && this.state.types[i].services.length > 0 &&
                      <li className = {this.state.current_step == 'servicesData'+i ? "active" : ""}><a onClick={() => this.setCurrentStep('servicesData'+i)} href={'#servicesData'+i}
                                                                                                       data-toggle="tab">{this.state.types[i]['name']}</a></li>
                  ))
                }
                <li className = {this.state.current_step == 'checkoutList' ? "active" : ""}><a onClick={() => this.setCurrentStep('checkoutList')} href="#checkoutList" data-toggle="tab">Megrendelés összesítése</a></li>
              </ul>
            </div>
            <div className="panel-body">
              <div className="tab-content">
                <div className="tab-pane fade active in" id="orderData">
                  {this.OrderData()}
                </div>
                {this.ServicesData()}
                <div className="tab-pane fade" id="checkoutList">
                  {this.CheckoutData()}
                </div>
                {this.Buttons()}
              </div>
            </div>
          </div>
        </div>
        {(this.state.cartItems > 0 && this.state.current_step != 'checkoutList') &&
            <div className="col-md-5">
              {this.Checkout()}
            </div>
        }

        </div>
      </form>
      </>)
    } else {
      return (<>Betöltés</>)
    }
  }
}